import React, { useState } from "react";
import Card from "../components/Card";
import Button from "../components/Button";
import Input from "../components/Input";

export default function PasarelaPago({ oferta, onResult }) {
  /*
    props cuando conectemos backend:

    oferta = {
      postId,
      titulo,
      tipo,
      montoOriginal,
      montoOferta,
      compradorId,
      clienteId
    }

    onResult("success")  → pago aprobado
    onResult("failed")   → pago rechazado
  */


  const data = oferta || {
    postId: 1,
    titulo: "Cheque #221",
    tipo: "cheque",
    montoOriginal: 5000000,
    montoOferta: 4700000,
  };

  const [form, setForm] = useState({
    nombre: "",
    documento: "",
    tarjeta: "",
    vencimiento: "",
    cvv: "",
  });

  const [error, setError] = useState("");

  const procesarPago = () => {
    if (
      !form.nombre ||
      !form.documento ||
      !form.tarjeta ||
      !form.vencimiento ||
      !form.cvv
    ) {
      setError("Complete todos los campos del formulario.");
      return;
    }

    setError("");

    // SIMULACIÓN del resultado
    const resultado = Math.random() < 0.8 ? "success" : "failed";

    if (onResult) {
      onResult(resultado);
    } else {
      alert(resultado === "success" ? "Pago aprobado" : "Pago rechazado");
    }
  };

  return (
    <div className="space-y-6">
      {/* ---------- Título ---------- */}
      <h1 className="text-2xl font-bold text-primary">Pasarela de Pago</h1>

      <p className="text-slate-600">
        Complete los datos para procesar el pago de la operación.
      </p>

      {/* ---------- Resumen de operación ---------- */}
      <Card>
        <h2 className="text-lg font-semibold text-primary mb-3">
          Resumen de la operación
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
          <p>
            <b>Documento:</b> {data.titulo}
          </p>
          <p>
            <b>Tipo:</b> {data.tipo}
          </p>
          <p>
            <b>Monto original:</b>{" "}
            <b className="text-primary">
              Gs {data.montoOriginal.toLocaleString("es-PY")}
            </b>
          </p>
          <p>
            <b>Monto a pagar:</b>{" "}
            <b className="text-emerald-700">
              Gs {data.montoOferta.toLocaleString("es-PY")}
            </b>
          </p>
        </div>
      </Card>

      {/* ---------- Formulario de datos del comprador ---------- */}
      <Card className="space-y-4">
        <h2 className="text-lg font-semibold text-primary">
          Datos del comprador
        </h2>

        <Input
          label="Nombre del representante"
          value={form.nombre}
          onChange={(e) => setForm({ ...form, nombre: e.target.value })}
        />

        <Input
          label="Documento / RUC"
          value={form.documento}
          onChange={(e) => setForm({ ...form, documento: e.target.value })}
        />

        <Input
          label="Número de tarjeta"
          placeholder="0000 0000 0000 0000"
          value={form.tarjeta}
          onChange={(e) => setForm({ ...form, tarjeta: e.target.value })}
        />

        <div className="grid grid-cols-2 gap-4">
          <Input
            label="Vencimiento (MM/AA)"
            placeholder="06/27"
            value={form.vencimiento}
            onChange={(e) => setForm({ ...form, vencimiento: e.target.value })}
          />
          <Input
            label="CVV"
            placeholder="123"
            type="password"
            value={form.cvv}
            onChange={(e) => setForm({ ...form, cvv: e.target.value })}
          />
        </div>

        {error && <p className="text-red-600 text-sm">{error}</p>}

        <Button className="w-full mt-3" onClick={procesarPago}>
          Procesar Pago
        </Button>
      </Card>

      {/* ---------- Notas legales ---------- */}
      <p className="text-xs text-slate-500 text-center">
        Los datos ingresados son utilizados únicamente con fines de validación.
        En un entorno real se reemplazará por una pasarela de pago segura.
      </p>
    </div>
  );
}
